//#region src/order_payment_destination.ts
var OrderPaymentDestination = /* @__PURE__ */ function(OrderPaymentDestination) {
	OrderPaymentDestination[OrderPaymentDestination["None"] = 0] = "None";
	OrderPaymentDestination[OrderPaymentDestination["CreditCard"] = 1] = "CreditCard";
	OrderPaymentDestination[OrderPaymentDestination["EmployeeId"] = 2] = "EmployeeId";
	OrderPaymentDestination[OrderPaymentDestination["Cashier"] = 3] = "Cashier";
	return OrderPaymentDestination;
}(OrderPaymentDestination || {});
//#endregion
export { OrderPaymentDestination };

//# sourceMappingURL=order_payment_destination.js.map